import { cva } from 'class-variance-authority';

/**
 * Softphone Component Variants
 *
 * All variants are centralized here for easier maintenance and scalability.
 * This approach ensures:
 * - Consistent styling across all Softphone sub-components
 * - Single source of truth for variant definitions
 * - Easy to add new variants (e.g., 'compact', 'expanded') in the future
 * - Type-safe variant usage with CVA
 *
 * Variants:
 * - fixed: Sidebar mode (smaller spacing, compact avatar)
 * - popup: Draggable window mode (larger spacing, prominent avatar)
 */

export const softphoneVariants = cva(
  'flex flex-col items-center bg-background scroll-area-content',
  {
    variants: {
      variant: {
        fixed: '',
        popup: '',
      },
      transferActive: {
        true: '',
        false: 'pb-[46px]',
      },
    },
    compoundVariants: [
      {
        variant: 'popup',
        transferActive: true,
        class: 'h-[512px] max-h-full',
      },
    ],
    defaultVariants: {
      variant: 'fixed',
      transferActive: false,
    },
  }
);

export const avatarVariants = cva('bg-foreground', {
  variants: {
    variant: {
      fixed: 'size-[80px]',
      popup: 'size-[70px]',
    },
  },
  defaultVariants: {
    variant: 'fixed',
  },
});

export const connectionStatusVariants = cva('flex flex-row w-full justify-end h-[24px] mt-[12px] px-[12px]', {
  variants: {
    variant: {
      fixed: 'mb-[12px]',
      popup: '-mb-[6px]',
    },
  },
  defaultVariants: {
    variant: 'fixed',
  },
});

export const keypadGridVariants = cva('grid grid-cols-3 gap-x-[12px] place-items-center', {
  variants: {
    variant: {
      fixed: 'gap-y-[8px] my-[24px]',
      popup: 'gap-y-[4px] my-[16px]',
    },
  },
  defaultVariants: {
    variant: 'fixed',
  },
});

export const transferSearchListVariants = cva('flex-1 overflow-y-auto scroll-area-content min-h-0', {
  variants: {
    variant: {
      fixed: 'max-h-[calc(100vh-230px)]',
      // No cap in the popup: the window height is fixed while transferring, so
      // the list simply fills the space the header and search input leave.
      popup: '',
    },
  },
  defaultVariants: {
    variant: 'popup',
  },
});
